import { ConfigConsumerProps } from '../../config-provider/configConsumerProps';

import { omit, cloneDeep } from 'lodash-es';

export default {
  name: 'FcDatePicker',
  props: {
    item: Object,
    filtersCurrent: Object,
    form: Object,
    wrapClass: String,
  },
  data() {
    return {
      open: false,
    };
  },
  watch: {},
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },

  created() {},
  mounted() {},
  methods: {
    // 弹出日历和关闭日历的回调
    openChange(status) {
      this.open = status;
    },
    // 弹出之后,操作面板时的展示
    panelChange(value) {
      this.form.setFieldsValue({ [this.item.field]: value }); // 使用 setFieldsValue 设置表单字段的值
      this.open = false;
      this.$emit('change', event || {});
    },
    // clearValue 点击全删 才会触发
    clearValue(event, item) {
      if (item && item.change) {
        item.change();
      }

      this.form.setFieldsValue({ [this.item.field]: null }); // 使用 setFieldsValue 清除表单字段的值
      this.$nextTick(() => {
        this.$emit('change', event || {});
      });
    },
  },
  render(h) {
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-table');

    const { item, filtersCurrent, wrapClass } = this;
    return (
      <a-form-item
        class={wrapClass}
        label={item.label ? item.label : null}
        colon={false}
        validateStatus={item.validateStatus || ''}
        help={item.help || ''}
        labelAlign={filtersCurrent.labelAlign || 'left'}
        style={filtersCurrent.formItemStyle || ''}
        label-col={wrapClass && wrapClass.includes('advance') ? { span: 24 } : { span: 6 }}
        wrapper-col={wrapClass && wrapClass.includes('advance') ? { span: 24 } : { span: 18 }}
      >
        <a-date-picker
          class={`${prefixCls}-filterwrap`}
          {...{ props: omit(item, 'value') }}
          {...{ on: omit(item, 'change', 'onUpdate:value', 'openChange', 'panelChange') }}
          v-decorator={[item.field, { rules: item.rules, initialValue: item.defaultValue }]}
          onChange={e => {
            this.clearValue(e, item);
          }}
          onOpenChange={this.openChange}
          onPanelChange={this.panelChange}
          format="YYYY"
          mode="year"
          open={this.open}
          placeholder={item.placeholder || '请选择'}
          style={item.style || ''}
        />
      </a-form-item>
    );
  },
};
